import React from "react";

import { graphql } from "gatsby";
import PropTypes from "prop-types";

import KontentItemImage from "./kontentItemImage";
import ArticleTeaser from "../components/articleTeaser/articleTeaser";
import ArticleTeaserEmbed from "../components/articleTeaserEmbed/articleTeaserEmbed";

const KontentItemArticlesEmbed = ({ data }) => {
  const articleTeaser = data.value ? data.value[0] : data;

  if (!articleTeaser || !articleTeaser.elements) {
    return null;
  }

  return (
    <ArticleTeaserEmbed>
      {articleTeaser.elements.article_teasers.value.map((item) => {
        if (item.id) {
          let options = null;

          // eslint-disable-next-line no-underscore-dangle
          switch (item.__typename) {
            case "kontent_item_news_article":
              options = {
                variant: "news",
              };
              break;
            default:
          }

          return (
            <ArticleTeaser
              key={item.id}
              headline={item.elements.headline.value}
              url={item.id}
              image={
                item.elements.hero_image.value.length > 0
                  ? (
                    <KontentItemImage
                      data={item.elements.hero_image}
                      height={120}
                      crop
                      aspectRatio={1}
                    />
                  )
                  : null
              }
              {...options}
            />
          );
        }

        return null;
      })}

    </ArticleTeaserEmbed>
  );
};

export const query = graphql`
  fragment KontentItemArticlesEmbed on kontent_item_articles_embed {
    id
    system {
      codename
    }
    elements {
      article_teasers {
        value {
          ... on kontent_item_news_article {
            id
            elements {
              headline {
                value
              }
              hero_image {
                value {
                  ...KontentItemImage
                }
              }
            }
          }
        }
      }
    }
  }
`;

KontentItemArticlesEmbed.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default KontentItemArticlesEmbed;
